module.exports = __webpack_public_path__ + "img/Eye_Wear.d19282e1.jpg";